import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AppSettings } from './../../config/app-settings.js';
import { connect } from 'react-redux';
import Loading from '../../components/loading/Loading.jsx';


class Login extends Component {
  static contextType= AppSettings;
  constructor(props) {
    super(props);
    this.state = { 
      loadingSubmit: false,
      shouldNavigate: false,
     }
  }
  UNSAFE_componentWillMount() {
    this.context.handleSetAppSidebarNone(true);
    this.context.handleSetAppHeaderNone(true);
    this.context.handleSetAppContentClass('p-0');
  }
  componentWillUnmount() {
    this.context.handleSetAppContentClass('');
  }
  componentDidUpdate(prevProps) {
    console.log(prevProps);
    if (this.props.login.error) {
      toast.error(this.props?.login?.error)
      this.setState({ loadingSubmit: false });
      this.props.reset()
    }
    if (this.props.login.isLogged !== prevProps.login.isLogged) {      
      this.setState({ shouldNavigate: true, loadingSubmit: false});
      // this.props.check()
      // if(this.props.login.isLogged){
      //   toast.success('Bienvenido')
      // } 
    }
  }

   handleSubmit = async(event) => {
    event.preventDefault();
    this.setState({...this.state, loadingSubmit: true });
    try{
      if(event.target.id.value==='' || event.target.password.value===''){
        toast.error('Llene todos los campos')
        this.setState({ loadingSubmit: false });
        return;
      }
      this.props.signin({
       
          id:event.target.id.value, 
          password:event.target.password.value  
       
      })        
    }catch(error){
      console.log(error)
      toast.error('Error al iniciar sesion')
      this.setState({ loadingSubmit: false });
    }
    
  };

  
  render() { 
    return ( 
      <div className="login login-with-news-feed">
        <Loading toggle={this.state.loadingSubmit} />
        {this.state.shouldNavigate && <Navigate to="/" />  }
      <div className="news-feed">
        <div className="news-image" style={{backgroundImage: 'url(/assets/img/login-bg/login-bg-11.jpg)'}}></div>
        <div className="news-caption">
          <h4 className="caption-title"><b>Natura</b> KPI App</h4>
          <p>
            Pagina Indicadores.
          </p>
        </div>
      </div>
      <div className="login-container">
        <div className="login-header mb-30px">
          <div className="brand">
            <div className="d-flex align-items-center">
              <span className="logo"></span>
              <b>KPI</b> App
            </div>
            <small>Auntenticacion para indicadores</small>
          </div>
          <div className="icon">
            <i className="fa fa-sign-in-alt"></i>
          </div>
        </div>
        <div className="login-content">
          <form onSubmit={(e)=>this.handleSubmit(e)} className="fs-13px">
            <div className="form-floating mb-15px">
              <input type="text" className="form-control h-45px fs-13px" name='id' placeholder="Codigo Natura" id="emailAddress" />
              <label htmlFor="emailAddress" className="d-flex align-items-center fs-13px text-gray-600">Codigo Natura</label>
            </div>
            <div className="form-floating mb-15px">
              <input type="password" className="form-control h-45px fs-13px" name="password" placeholder="Contraseña" id="password" />
              <label htmlFor="password" className="d-flex align-items-center fs-13px text-gray-600">Contraseña</label>
            </div>
            {/* <div className="form-check mb-30px">
              <input className="form-check-input" type="checkbox" value="1" id="rememberMe" />
              <label className="form-check-label" htmlFor="rememberMe">
                Remember Me
              </label>
            </div> */}
            <div className="mb-15px">
              <button type="submit" className="btn btn-orange d-block h-45px w-100 btn-lg fs-14px">Ingresar</button>
            </div>
            {/* <div className="mb-40px pb-40px text-body">
              Not a member yet? Click <Link to="/user/register-v3" className="text-primary">here</Link> to register.
            </div> */}
            <hr className="bg-gray-600 opacity-2" />
            <div className="text-gray-600 text-center text-gray-500-darker mb-0">
              &copy; Alta Estetica SRL All Right Reserved 2024
            </div>
          </form>
        </div>
      </div>
    </div>
     );
  }
}
 const MapStateToProps = (state) => {
  return {
    login: state.login,
  };
};
const MapDispatchToProps = (dispatch) => {
  return {
    signin: (payload) => dispatch({ type: 'LOGIN_START', payload }),
    check: () => dispatch({ type: 'LOGIN_VERIFY'}),
    reset: () => dispatch({ type: 'LOGIN_RESET' }),

  };
};
export default connect(MapStateToProps, MapDispatchToProps)(Login);